import { createFileRoute, Navigate } from '@tanstack/react-router'

import { useIsAuthenticated } from '@/hooks'

/**
 * 首页路由
 * - 已认证用户重定向到仪表盘
 * - 未认证用户重定向到登录页
 */
export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  const { isAuthenticated, isLoading } = useIsAuthenticated()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-muted-foreground">加载中...</div>
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />
  }

  return <Navigate to="/login" search={{ token: undefined, error: undefined }} />
}
